import { useEffect, useState } from 'react';
import { getToken, TOKEN_UPDATED_EVENT } from 'utils/localStorage';

/**
 * Returns the current access token and re-renders the consumer whenever the
 * refresh-token cycle writes a new one (via the `toqio:token-updated` event)
 * or another tab updates localStorage (native `storage` event).
 */
export const useAccessToken = (): string | null => {
  const [token, setTokenState] = useState<string | null>(() => getToken());

  useEffect(() => {
    const sync = (): void => setTokenState(getToken());
    window.addEventListener(TOKEN_UPDATED_EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(TOKEN_UPDATED_EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  return token;
};
